/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Pagination } from '../models/Pagination';
import type { Workflow } from '../models/Workflow';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WorkflowsService {

    /**
     * Export a Workflow
     * Returns a complete JSON representation of the workflow including all stages, stage configuration, rules, and message templates. Compatible with POST /internal_api/workflows/import.
     * @param id External ID of the workflow to export
     * @param xAccessToken
     * @returns any OK
     * @throws ApiError
     */
    public static getInternalApiWorkflowsExport(
        id: string,
        xAccessToken: string,
    ): CancelablePromise<{
        id?: number;
        external_id?: string;
        title?: string;
        description?: string | null;
        exported_at?: string;
        stages?: Array<any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/workflows/{id}/export',
            path: {
                'id': id,
            },
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Import a Workflow
     * Imports a workflow from a serialized export payload as returned by GET /internal_api/workflows/{id}/export.
     * @param xAccessToken
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static postInternalApiWorkflowsImport(
        xAccessToken: string,
        requestBody: any,
    ): CancelablePromise<{
        id?: string;
        title?: string;
        description?: string | null;
        locale?: string | null;
        country_code?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/workflows/import',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                422: `Unprocessable Entity`,
            },
        });
    }

    /**
     * Requests Workflows
     * Returns workflows for the logged in user
     * @param title filter query for title
     * @param stageId filter query for stage external id
     * @param page page number in result set
     * @param sortBy field to sort results by
     * @param sortDirection direction to sort results
     * @param includeStages when true, each workflow includes its stages (and sub-stages)
     * @returns any includes stages when include_stages=true
     * @throws ApiError
     */
    public static getInternalApiWorkflows(
        title?: string,
        stageId?: string,
        page?: number,
        sortBy?: string,
        sortDirection?: 'asc' | 'desc',
        includeStages?: boolean,
    ): CancelablePromise<{
        workflows: Array<Workflow>;
        pagination: Pagination;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/workflows',
            query: {
                'title': title,
                'stage_id': stageId,
                'page': page,
                'sort_by': sortBy,
                'sort_direction': sortDirection,
                'include_stages': includeStages,
            },
        });
    }

    /**
     * Requests Workflows
     * Returns workflow by ID
     * @param workflowId find workflow by ID
     * @returns Workflow successful
     * @throws ApiError
     */
    public static getInternalApiWorkflows1(
        workflowId: string,
    ): CancelablePromise<Workflow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/workflows/{workflow_id}',
            path: {
                'workflow_id': workflowId,
            },
        });
    }

}